export default __webpack_public_path__ + "static/media/prairie-dog.f1e91e3a.webp";